declare global {
  // Manually for used functions. Referencing https://docs.prebid.org/dev-docs/publisher-api-reference.html
  namespace pbjs {
    const que: (() => void)[];
    const rp: {
      requestBids: (request: {
        adUnitCodes?: string[];
        callback?: () => void;
        gptSlotObjects?: googletag.Slot[];
      }) => Promise<BidsResponse>;
    };
    function requestBids(request: { adUnitCodes: string[] }): Promise<BidsResponse>;

    type BidsResponse = { auctionId: string; bids: Record<string, unknown>; timedOut: boolean };
  }
}

export const requestBids = (slot: googletag.Slot) => {
  const result = new Promise<pbjs.BidsResponse>((resolve, reject) => {
    pbjs.que.push(async () => {
      try {
        const response = await pbjs.rp.requestBids({ gptSlotObjects: [slot] });
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  });

  return { result };
};
